import React, { createContext, useState, useEffect } from "react";
import {
  NoEthereumProviderError,
  UserRejectedRequestError as UserRejectedRequestErrorInjected,
} from "@web3-react/injected-connector";
import { injected } from "./connectors";
import { useWeb3React } from "@web3-react/core";
import { toast } from "react-toastify";

interface IMinted {
  minted: boolean | number;
}

interface IMint {
  count: number;
}

type DefaultContext = {
  contract: any;
  wallet: boolean;
  mintNowCount: IMint;
  mintLeft: IMinted;
  active: boolean;
  handleConnectWallet: (wallet: boolean) => void;
  handleContract: (abi: Array<Object>, address: string) => void;
  handleMintNowCount: (mintNowCount: number) => void;
  handleMintLeft: (minted: boolean) => void;
};

const contextDefaultValues: DefaultContext = {
  contract: "",
  wallet: false,
  mintNowCount: { count: 1 },
  mintLeft: { minted: false },
  active: false,
  handleMintNowCount: () => null,
  handleContract: () => null,
  handleConnectWallet: () => null,
  handleMintLeft: () => null,
};

export const GlobalContext =
  createContext<DefaultContext>(contextDefaultValues);
interface Props {
  children: React.ReactNode;
}

const contract = require("../data/contract/RocknBonesNFTRemix.json");
const abi = contract["abi"];
const address = contract["address"];


const ContextProvider: React.FC<Props> = ({ children }) => {
  const { active, account, library, connector, activate, deactivate } =
    useWeb3React();
  const [contract, setContract] = useState<any>();
  const [wallet, setWallet] = useState<boolean>(false);
  const [walletSet, setWalletSet] = useState<boolean>(false);
  const [mintNowCount, setMintNow] = useState<IMint>({ count: 1 });
  const [mintLeft, setMintLeft] = useState<IMinted>({ minted: false });
  const [balanceAccount, setBalanceAccount] = useState<string>("");

  const handleContract = (abi: Array<Object>, address: string) => {
    if (library !== undefined) {
      setContract(new library.eth.Contract(abi, address));
    }
  };

  const fetchBalance = async () => {
    if (library !== undefined) {
      library.eth.getBalance(account).then((response: string) => {
        setBalanceAccount(`${Number(response) / 1000000000000000000}`);
      });
    }
  };

  const handleConnectWallet = (wallet: boolean) => {
    setWallet(wallet);
  };

  const handleDisconnectWallet = (wallet: boolean) => {
    setWallet(wallet);
  };

  const handleMintNowCount = (mintNowCount: number) => {
    setMintNow({ count: mintNowCount });
  };

  const handleMintLeft = (minted: boolean) => {
    setMintLeft({ minted: minted });
  };

  const connectWallet = async () => {
    try {
      const connected = await activate(injected);

      Promise.resolve(connected)
        .then((value) => {})
        .then((value) => {
          if (wallet && value) {
            setWalletSet(true);
          } else {
            setWallet(false);
          }
        });
    } catch {
      toast("Make sure you have Metamask Wallet")
    }
  };

  const getSupply = async () => {
    try{

      const supply_left = await contract.methods.mintableLeft();
      Promise.resolve(supply_left)
        .then((value) => value.call())
        .then((value) => {
          setMintLeft({ minted: 6006 - value});
        });

    }catch(e){
      toast("Could not get mintable left!")
    }
    
  };

  const mintNow = async (selectMintableAmount: number) => {
    const sendAmount = 15000000000000000 * selectMintableAmount;
    const number_of_mints = selectMintableAmount;

    try {
      const minted_list = await contract.methods
        .mintSale(account, number_of_mints)
        .send({ from: account, value: sendAmount });

      Promise.resolve(minted_list)
        .then((value) => {
          toast(`Minted Items in Hash ${value.blockHash}`, {
            autoClose: false,
            icon: "🤭",
            closeOnClick: true,
          });
        })
        .catch((e) => console.log(e));
    } catch (e) {
      toast("Your transaction has been cancelled!");
    }
  };

  useEffect(() => {
    if (wallet) {
      connectWallet();
    }
  }, [wallet]);

  useEffect(() => {
    if (library !== undefined) {
      setContract(new library.eth.Contract(abi, address));
    }
  }, [library]);

  useEffect(() => {
    setWallet(active);
  }, [active]);

  useEffect(() => {}, [walletSet]);

  useEffect(() => {
    if (account) {
      fetchBalance();
    }
  }, [account]);

  useEffect(() => {
    if (contract !== undefined && account !== undefined) {
      mintNow(mintNowCount.count);
    }
  }, [mintNowCount]);


  useEffect(() => { 
    if (contract) {
      getSupply()
    }
  }, [contract])

  return (
    <GlobalContext.Provider
      value={{
        contract,
        handleContract,

        mintNowCount,
        handleMintNowCount,

        mintLeft,
        handleMintLeft,

        wallet,
        handleConnectWallet,

        active
      }}
    >
            {children}   {" "}
    </GlobalContext.Provider>
  );
};

export default ContextProvider;
